<template>
  <div class="m-portlet">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">
            Tags
          </h3>
        </div>
      </div>
    </div>
    <div class="m-portlet__body">
      <div class="flex align-items-center">
        <input
          placeholder="Tag"
          style="width: 200px; margin-right: 10px;"
          type="text"
          class="form-control"
          v-model="tag_name">
        <div class="btn btn-jet" @click="add()">Add</div>
      </div>
      <div class="flex mt-3">
        <div class="tag mr-1 mb-1" v-for="tag in tags">
          <span>{{ tag.name }}</span>
          <span class="ml-1 pointer" @click="remove(tag)">x</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.axios.get('/n/tags').then(response => {
      this.tags = response.data.data
    })
  },
  data() {
    return {
      tags: [],
      tag_name: null,
    }
  },
  methods: {
    add() {
      this.axios.post('/n/tags', {name: this.tag_name}).then(response => {
        this.tags.push(response.data.data)
        this.tag_name = null
      })
    },
    remove(tag) {
      if (!confirm('Are you sure? All tasks will lose this tag.')) {
        return
      }

      this.axios.delete('/n/tags/' + tag.id).then(response => {
        this.tags  = _.reject(this.tags, t => t.id == tag.id)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/config/tags.vue